export const SOURCE_ID_MAP = {
  PC_OFFICIAL: 1, // PC 官网
  MICRO_TERMINAL: 2, // 微端
  WEB_STORE: 3, // 网页商城
}

export const SOCIAL_MAP = {
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  FUNPLUS_ID: 'funplus_id',
  VK: 'vk',
  DISCORD: 'discord'
}

export const SOCIAL_CODE_MAP = {
  [SOCIAL_MAP.FACEBOOK]: 10,
  [SOCIAL_MAP.VK]: 12,
  [SOCIAL_MAP.GOOGLE]: 13,
  [SOCIAL_MAP.FUNPLUS_ID]: 23,
  [SOCIAL_MAP.DISCORD]: 21
}

// google 账号
export const GOOGLE_ACCOUNT_MAP = {
  // ss
  30001: '1032230406505-eo8k4ct4ec3v92f2jc1ce23lt0u7622f.apps.googleusercontent.com',
  // ss jp
  30010: '268102245793-1sqpnm47dh4na0eciq8j1dtdnhmgt6j8.apps.googleusercontent.com',
  // ss kr
  30007: '1032230406505-eo8k4ct4ec3v92f2jc1ce23lt0u7622f.apps.googleusercontent.com',
  // koa
  2031: '839054467581-922v7ikf7n00r31u9hp5kufbhhjem3ge.apps.googleusercontent.com',
  // koa-rom
  5403: '106628238351-t2itusij8se48rqnk2esulskr8aa1fup.apps.googleusercontent.com',
  // gog
  2064: '839054467581-vpsfunq1avhb5fc3re8ejap1dc313f7c.apps.googleusercontent.com',
  // mc_global
  2200: '664145535902-bb7eb8mutjhfc3401mga4q0u8oqbj939.apps.googleusercontent.com',
  // st_global
  2202: '642191732076-2839q0nkps4nk4t18cbcaclfcgtkkbvf.apps.googleusercontent.com',
  // st2_global
  5105: '642191732076-2839q0nkps4nk4t18cbcaclfcgtkkbvf.apps.googleusercontent.com',
  // antia
  100013: '29995148299-85g4vn6vnrjscd8uhsgj7r8jad6rlihc.apps.googleusercontent.com',
  // entropy
  60004: '199246723891-0c22q620k8c0qgapbjf6gvv5pvdn5k6n.apps.googleusercontent.com',
  // mo
  70001: '777624363258-06e7rli2tp6v8ueg1k9o5hn2d88mgeun.apps.googleusercontent.com',
  // dc
  'dc.global.prod': '274302385578-ofv1hposme9gnuj0a8n32rucpgfqj33b.apps.googleusercontent.com',
  // foundation
  'foundation.global.prod': '579034311168-uig6ioebvu3vj0vv5jpvr5sab1ol3osc.apps.googleusercontent.com'
}

// facebook 账号
export const FACEBOOK_ACCOUNT_MAP = {
  // ss
  30001: '2265962980317021',
  // ss jp
  30010: '182753510395927',
  // ss kr
  30007: '3088190731299831',
  // koa
  2031: '969208706496578',
  // koa-rom
  5403: '1812548022597863',
  // gog
  2064: '233784533798304',
  // mc_global
  2200: '1059494967972313',
  // st_global
  2202: '877717156966709',
  // st2_global
  5105: '341712278880956',
  // antia
  100013: '2920772608183999',
  // entropy
  60004: '793582415326715',
  // mo
  70001: '811523543802991',
  // dc
  'dc.global.prod': '1411045516218795',
  // foundation
  'foundation.global.prod': '524516057171015',
}

// Discord 账号
export const DISCORD_ACCOUNT_MAP = {
  // dcdl
  'dc.global.prod': '1308351868719857724'
  // 1286209112882942012
}

// 帮助配置
export const HELP_CONFIG = {
  // ss
  30001: {
    other: 'https://sos.kingsgroupgames.com/pc/faq',
    [SOURCE_ID_MAP.PC_OFFICIAL]: 'https://sos.kingsgroupgames.com/pc/faq',
    [SOURCE_ID_MAP.WEB_STORE]: 'https://ss-pay.funplus.com/ss/faq'
  },
  // ss jp
  30010: {
    other: 'https://sos.kingsgroupgames.com/pc/faq',
    [SOURCE_ID_MAP.PC_OFFICIAL]: 'https://sos.kingsgroupgames.com/pc/faq',
    [SOURCE_ID_MAP.WEB_STORE]: 'https://ss-pay.funplus.com/ss/faq'
  },
  // ss kr
  30007: {
    other: 'https://sos.kingsgroupgames.com/pc/faq',
    [SOURCE_ID_MAP.PC_OFFICIAL]: 'https://sos.kingsgroupgames.com/pc/faq',
    [SOURCE_ID_MAP.WEB_STORE]: 'https://ss-pay.funplus.com/ss/faq'
  },
  // koa
  2031: {
    other: 'https://koa.kingsgroupgames.com/pc/faq',
    [SOURCE_ID_MAP.PC_OFFICIAL]: 'https://koa.kingsgroupgames.com/pc/faq',
    [SOURCE_ID_MAP.WEB_STORE]: 'https://koa-store.funplus.com/koa/faq'
  },
  // gog
  2064: {
    other: '',
    [SOURCE_ID_MAP.WEB_STORE]: 'https://gog-store.funplus.com/gog/faq'
  },
  // antia
  100013: {
    other: '',
    [SOURCE_ID_MAP.WEB_STORE]: 'https://antia-store.funplus.com/antia/faq'
  },
  // antia
  60004: {
    other: '',
    [SOURCE_ID_MAP.WEB_STORE]: ''
  }
}

// 自定义打点上报 app id
export const CUSTOM_LOG_APP_ID = {
  30001: '627a1da83e6d9717222693d5',
  2031: '62fef5d838fd9e09520e7c34',
  2062: '62fef5d838fd9e09520e7c34'
}

// 各游戏社媒登录方式
export const GAME_SOCIAL_TYPES = {
  // ss
  30001: ['Facebook', 'Google'],
  // ss jp
  30010: ['Facebook', 'Google'],
  // ss kr
  30007: ['Facebook', 'Google'],
  // koa
  2031: ['Facebook', 'Google'],
  // koa cn
  2062: [],
  // gog
  2064: ['Facebook', 'Google'],
  // mc_global
  2200: ['Facebook', 'Google'],
  // st_global
  2202: ['Facebook', 'Google'],
  // st2_global
  5105: ['Facebook', 'Google'],
  // antia
  100013: ['Facebook', 'Google'],
  // entropy
  60004: ['Facebook', 'Google'],
  // mo
  70001: ['Facebook', 'Google'],
  // dc
  'dc.global.prod': ['Facebook', 'Google', 'Discord'],
  // foundation
  'foundation.global.prod': ['Facebook', 'Google']
}

// cn 包
export const FP_CN_GAMES = [2062]

// user加密前缀 + ' 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83'
export const GAME_ID_ASCII = {
  30001 : '116 116 96 104 109 112 99 98 109 79 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  2031  : '108 112 98 96 104 109 112 99 98 109 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  2062  : '108 112 98 96 104 109 112 99 98 109 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  5403  : '108 112 98 96 104 109 112 99 98 109 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  2064  : '104 112 104 96 104 109 112 99 98 109 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  2200  : '110 100 96 104 109 112 99 98 109 79 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  2202  : '116 117 96 104 109 112 99 98 109 79 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  5105  : '116 117 96 104 109 112 99 98 109 79 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  70001 : '110 112 96 104 109 112 99 98 109 79 79 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  60004 : '102 111 117 115 112 113 122 96 104 109 112 99 98 109 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  100013: '98 111 117 106 98 96 104 109 112 99 98 109 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83',
  'dc.global.prod': '101 100 101 109 96 104 109 112 99 98 109 112 80 91 111 108 36 112 51 114 99 114 68 102 82 67 50 106 89 102 74 83'
}

export const GAME_PROJECT_MAP = {
  "2031":   'koa_global',
  "2062":   'koa_global',
  "5403":   'koa_global',
  "2064":   'gog_global',
  "2067":   'gog_cn',
  "2202":   'st_global',
  "5105":   'st_global',
  "2200":   'mc_global',
  "2203":   'mc_cn',
  "30001":  'ss_global',
  "30010":  'ss_global',
  "30007":  'ss_global',
  "70001":  'mo_global',
  "60004":  'entropy_global',
  "100013": 'antia_global',
  "dc.global.prod": 'dcdl_global',
  "foundation.global.prod": 'foundation_global',
}

export const OAUTH_TYPES = {
  PASSPORT_LOGIN: 'passport',
  GAME_LOGIN: 'game'
}

export const vk2AppIdMap = {
  8612: '54096471',
  5105: '54471994',
  5403: '54476673',
  'dc.global.prod': '53156255',
  5431: '54602561',
  'worldx.global.prod': '54714199'
}

export default {
  SOURCE_ID_MAP,
  SOCIAL_MAP,
  SOCIAL_CODE_MAP,
  GOOGLE_ACCOUNT_MAP,
  FACEBOOK_ACCOUNT_MAP,
  GAME_SOCIAL_TYPES,
  GAME_ID_ASCII,
  GAME_PROJECT_MAP,
  DISCORD_ACCOUNT_MAP,
  OAUTH_TYPES
}
